import { ghostBtnClass, mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { useManufacturingOverheadPeriodValues } from "./useManufacturingOverheadPeriodValues";

type PeriodValuesState = ReturnType<typeof useManufacturingOverheadPeriodValues>;

export function ManufacturingPeriodCloseCard({ state }: { state: PeriodValuesState }) {
  const {
    plantId,
    summary,
    reopenReason,
    setReopenReason,
    copyActualsOnFinalize,
    setCopyActualsOnFinalize,
    materialsReconciliation,
    actionBusy,
    startClose,
    finalizeClose,
    reopenClose,
  } = state;

  if (!plantId || !summary) return null;

  const canStart = summary.period_state === "open" || summary.period_state === "reopened";
  const canFinalize = summary.period_state === "closing";
  const canReopen = summary.period_state === "closed";
  const materials = materialsReconciliation && materialsReconciliation.totals.scope_count > 0
    ? materialsReconciliation
    : null;

  return (
    <div className="mt-4 rounded-lg border border-gray-200 px-3 py-2 text-xs dark:border-zinc-700">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-semibold text-gray-900 dark:text-zinc-100">Period close</span>
        <span className="text-gray-600 dark:text-zinc-400">{summary.period_state}</span>
        {canStart ? (
          <button type="button" className={ghostBtnClass} disabled={actionBusy} onClick={() => void startClose()}>
            Start close
          </button>
        ) : null}
        {canFinalize ? (
          <>
            <button type="button" className={mfgPrimaryBtnClass} disabled={actionBusy} onClick={() => void finalizeClose()}>
              Finalize close
            </button>
            <label className="flex items-center gap-1 text-gray-700 dark:text-zinc-300">
              <input
                type="checkbox"
                checked={copyActualsOnFinalize}
                onChange={(event) => setCopyActualsOnFinalize(event.target.checked)}
                disabled={actionBusy}
              />
              Copy actuals into next month
            </label>
          </>
        ) : null}
        {canReopen ? (
          <>
            <input
              type="text"
              className="min-w-[12rem] rounded-lg border border-gray-200 bg-white px-2 py-1 dark:border-zinc-700 dark:bg-zinc-900"
              value={reopenReason}
              onChange={(event) => setReopenReason(event.target.value)}
              disabled={actionBusy}
              placeholder="Reopen reason"
              aria-label="Reopen reason"
            />
            <button type="button" className={ghostBtnClass} disabled={actionBusy} onClick={() => void reopenClose()}>
              Reopen
            </button>
          </>
        ) : null}
      </div>
      {materials ? (
        <p className="mt-2 text-amber-950 dark:text-amber-100">
          Materials: predicted ${materials.totals.predicted_materials_usd.toLocaleString()} vs issued $
          {materials.totals.actual_issuance_usd.toLocaleString()} books $
          {materials.totals.variance_usd.toLocaleString()} into waste on finalize.
        </p>
      ) : null}
    </div>
  );
}
